import React from "react";
import BaseReactSelectDropdown from "./BaseReactSelectDropdown";
import { useQuery } from "@tanstack/react-query";
import { type DropdownProps } from "../models";

interface Props extends DropdownProps<server.dto.FreeFieldCategoryForList> {
  mainArea: server.dto.MainAreas
}

const FreeFieldCategoryDropdown = (props: Props) => {
  const previousMainArea = React.useRef(props.mainArea);
  const query = useQuery({
    queryFn: async () => window.CoreApi.FreeFieldCategory.List(props.mainArea).then(r => r.data.data),
    queryKey: ["freeFieldCategories", props.mainArea],
    enabled: !props.options,
    initialData: props.options ?? [],
    onSuccess: (res) => {
      if (previousMainArea.current !== props.mainArea) {
        props.onChange(res[0] as any);
        previousMainArea.current = props.mainArea;
      }
    }
  });

  return <BaseReactSelectDropdown
    excludeKeys={props.excludeKeys}
    options={query.data}
    getLabel={ffc => ffc.title}
    getValue={ffc => ffc.freeFieldCategoryId}
    value={props.value}
    onChange={props.onChange}
    config={{
      isSearchable: false,
      ...props.config
    }}
    renderOption={(ffc) => <div className="flex align-center">
      <span>{ffc.title}</span>
    </div>}
    renderSelectedValue={(ffc) => <div className="flex align-center">
      <span>{ffc.title}</span>
    </div>}
  />;
};

export default FreeFieldCategoryDropdown;